import { crudMutations, readOnlyActions } from '../modules/action-helpers'

const basePath = 'api/rol'

export default {
  namespaced: true,
  basePath: basePath,
  state: {
    items: [],
    count: 0,
    currentPage: 1,
    currentItem: null
  },
  mutations: {
    ...crudMutations()
  },
  actions: {
    ...readOnlyActions({ basePath: basePath })
  },
  getters: {
    objects (state) { return state.items }
  }
}



// WEBPACK FOOTER //
// ./src/store/masters/roles.js